/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'

const variableTemplate = /[%][{][A-Za-z0-9]+[}]/g
const replacedVariableTemplate = /(%|{|})/g

interface ITextParams {
  texts: object,
  startPath?: string,
}

export const text = ({ texts = {}, startPath }: ITextParams) => (path: string = '', params?: any) => {
  const text = _get(texts, `${startPath}.${path}`, _get(texts, path, ''))
  if (!params) {
    return text
  }
  const result = text.replace(variableTemplate, value => {
    const key = value.replace(replacedVariableTemplate, '')
    return _get(params, key)
  })
  return result
}

export const mergeTexts = (fallbackTexts = {}, newTexts = {}) => {
  return Object.entries({ ...fallbackTexts, ...newTexts }).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: value ? value : fallbackTexts[key],
  }), {})
}
